<template>
  <div class="text-center">
    <v-dialog
      v-model="showDialog"
      width="500"
      scrollable
      @click:outside="$emit('update:showDialog', false)"
    >
      <v-card style="max-height: 600px">
        <v-card-title class="lighten-2 textDefaultColor justify-center"> Yorumlar </v-card-title>

        <v-divider></v-divider>

        <loading-progress :status="loading" />

        <v-card-text v-if="!loading" class="px-0" @scroll="onScroll">
          <div  id="scrollView">
            <v-list subheader two-line>
              <div v-for="(item, index) in commentData" :key="item.Id.concat(index.toString())">
                <!-- Main Comment -->
                <feed-comment-item
                  :item="item"
                  @commentAnswer="(n) => commentAnswer(n)"
                  @successDeleteComment="(n) => successDeleteComment(n)"
                />
                <div
                  v-if="item.ChildComments.length > 0"
                  v-for="(childItem, index) in item.ChildComments"
                  :key="childItem.Id"
                  class="ml-6"
                >
                  <!-- Child Comment -->
                  <feed-comment-item
                    :item="childItem"
                    @successDeleteComment="(n) => successDeleteComment(n)"
                    hideAnswerButton
                  />
                </div>
              </div>
              <loading-progress :status="loadMoreLoading" />
            </v-list>
          </div>
        </v-card-text>

        <v-card-actions
          v-if="replyingTo"
          class="commentAnswerDescription white--text body-2 py-1"
        >
          {{ replyingTo }} {{ $t("comment.replyingTo") }}
          <v-spacer />
          <v-btn small icon dark @click="commentAnswerClose">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider class="mb-3" v-if="!loading"></v-divider>
        <v-card-actions v-if="!loading">
          <v-layout row wrap align-center mb-2 pr-2>
            <v-text-field
              @keyup.enter="commentFeed"
              ref="commentTextField"
              :disabled="commentProgress"
              v-model.trim="commentText"
              class="px-2 mx-2"
              flat
              solo
              hide-details
              single-line
              full-width
              :placeholder="$t('add.comment')"
            ></v-text-field>
            <v-btn
              @click="commentFeed"
              :disabled="loading || !commentText.length > 0"
              :loading="commentProgress"
              outlined
              rounded
              class="text-capitalize mt-2 mr-2"
              color="defaultColor"
              >{{ $t("feed.shares") }}</v-btn
            >
            <vue-emoji-picker :marginTop="5" @selectEmoji="(emoji) => {commentText = [...commentText, emoji.data]}" />
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PostService from "../../services/PostService.js";
import FeedCommentItem from "./FeedCommentItem.vue";
import LoadingProgress from "../General/LoadingProgress.vue";
import VueEmojiPicker from "../Emoji/VueEmojiPicker.vue";
import ThanksDetailDialog from "../Thanks/ThanksDetailDialog.vue";

export default {
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: Boolean,
    commentData: [],
    commentText: "",
    commentProgress: false,
    loading: false,
    replyingTo: "",
    replyingToId: null,

    page: 1,
    pageSize: 10,
    noData: false,

    loadMoreLoading: false,
  }),
  components: {
    FeedCommentItem,
    LoadingProgress,
    VueEmojiPicker
  },
  methods: {
    //Get All Comment
    getComments() {
      if (this.commentData.length <= 0) this.loading = true;
      else this.loadMoreLoading = true;
      PostService.getPostComments(this.itemData.Id, this.page, this.pageSize)
        .then((res) => {
          console.log("comment",res.data)
          if (this.page != 1) {
            this.commentData = [...this.commentData, ...res.data];
          } else {
            this.commentData = res.data;
          }
          if (res.data.length < this.pageSize) {
            this.noData = true;
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.loading = false;
          this.loadMoreLoading = false;
        });
    },

    commentFeed(event) {
      if (this.replyingToId) {
        //Child Comment
        this.addChildComment(this.replyingToId);
      } else {
        //Main comment
        this.addMainComment(event);
      }
    },

    //Send Comment
    addMainComment(event, ParentId = null) {
      this.commentProgress = true;
      const body = {
        Text: this.commentText,
        ParentId,
      };
      //this.commentProgress = false;
      PostService.commentFeed(this.itemData.Id, body)
        .then((res) => {
          res.data.User = {
            Avatar: this.$store.state.user.Avatar,
            FullName: this.$store.state.user.FullName,
          };
          this.commentData.unshift(res.data);
          this.itemData.CommentCount++;
          this.commentText = "";
          document
            .getElementById("scrollView")
            .scrollIntoView({ behavior: "smooth" });
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.commentProgress = false;
        });
    },

    // Answer Comment
    commentAnswer(item) {
      this.replyingTo = item.User.FullName;
      this.replyingToId = item.Id;
      this.$refs.commentTextField.focus();
    },

    //Answer Comment Close
    commentAnswerClose() {
      this.replyingTo = "";
      this.replyingToId = null;
    },

    // Add Child Comment
    addChildComment(id) {
      const body = {
        Text: this.commentText,
        ParentId: id,
      };
      this.commentProgress = true;
      PostService.commentFeed(this.itemData.Id, body)
        .then((res) => {
          let index = this.commentData.findIndex((x) => x.Id == id);
          if (index) {
            res.data.User = {
              Avatar: this.$store.state.user.Avatar,
              FullName: this.$store.state.user.FullName,
            };
            this.commentData[index].ChildComments.push(res.data);
            this.itemData.CommentCount++;
          } else {
            this.getComments();
          }
          this.commentText = "";
          this.replyingTo = "";
          this.replyingToId = null;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.commentProgress = false;
        });
    },

    //Success Delete - CommentCountUpdate
    successDeleteComment(item) {
      this.itemData.CommentCount--;
    },

    loadMoreItems() {
      if (!this.noData && !this.loadMoreLoading && this.showDialog) {
        this.page++;
        this.getComments();
      }
    },

    onScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      console.log(scrollTop, offsetHeight, scrollHeight);
      if (scrollTop + offsetHeight + 50 >= scrollHeight) {
        this.loadMoreItems();
      }
    },

    clearDialog() {
      this.commentData = [];
      this.commentText = "";
      this.commentProgress = false;
      this.loading = false;
      this.replyingTo = "";
      this.replyingToId = null;

      this.page = 1;
      this.pageSize = 10;
      this.noData = false;

      this.loadMoreLoading = false;
    },
  },
  watch: {
    showDialog(newVal, oldVal) {
      if (newVal == true) {
        this.getComments();
        //this.getAnswers();
      } else {
        this.clearDialog();
      }
    },
  },
  computed: {
    getLikerUnderine() {
      if (this.itemData.LikeCount !== 0) {
        return "hover-underline";
      }
    },
  },
  destroyed() {},
  mounted() {},
};
</script>

<style></style>
